define( [ "./selector-sizzle" ], function() {} );



/*****************
 ** WEBPACK FOOTER
 ** ./~/jquery/src/selector.js
 ** module id = 436
 ** module chunks = 2
 **/